import { RESPONSE, ACCOUNT } from '~/constants'
import API from '~/apis/sbApi'
import { ACCOUNT as URLS, APP } from '~/constants/urls'

export const getProfileInformation = () => async (dispatch) => {
  try {
    dispatch({ type: ACCOUNT.CLEAR_PROFILE_INFORMATION })
    const response = await new API().get(`${URLS.profileInformation}`)
    dispatch({
      type: ACCOUNT.SET_PROFILE_INFORMATION,
      profileInformation: response.data?.user,
    })
  } catch (error) {
    dispatch({ type: RESPONSE.SET_ERROR, error })
  }
}

export const updateProfileInformation =
  (parameters, onSuccess, onError) => async (dispatch) => {
    try {
      dispatch({ type: ACCOUNT.SET_REQUEST_IS_PENDING, value: true })
      const response = await new API().put(URLS.profileInformation, parameters)
      dispatch({
        type: ACCOUNT.SET_PROFILE_INFORMATION,
        profileInformation: response.data?.user,
      })
      dispatch({ type: ACCOUNT.SET_REQUEST_IS_PENDING, value: false })
      onSuccess?.()
    } catch (error) {
      dispatch({ type: RESPONSE.SET_ERROR, error })
      dispatch({ type: ACCOUNT.SET_REQUEST_IS_PENDING, value: false })
      onError?.(error)
    }
  }

export const clearProfileInformation = () => ({
  type: ACCOUNT.CLEAR_PROFILE_INFORMATION,
})

export const changePassword =
  (parameters, onSuccess, onError) => async (dispatch) => {
    try {
      dispatch({ type: ACCOUNT.SET_REQUEST_IS_PENDING, value: true })
      await new API().put(URLS.password, parameters)
      dispatch({ type: ACCOUNT.SET_REQUEST_IS_PENDING, value: false })
      onSuccess?.()
    } catch (error) {
      dispatch({ type: RESPONSE.SET_ERROR, error })
      dispatch({ type: ACCOUNT.SET_REQUEST_IS_PENDING, value: false })
      onError?.(error)
    }
  }

export const getContacts = () => async (dispatch) => {
  try {
    dispatch({ type: ACCOUNT.CLEAR_CONTACTS })
    const response = await new API().get(`${URLS.contacts}`)
    dispatch({ type: ACCOUNT.SET_CONTACTS, contacts: response.data?.contacts })
  } catch (error) {
    dispatch({ type: RESPONSE.SET_ERROR, error })
  }
}

export const clearContacts = () => ({ type: ACCOUNT.CLEAR_CONTACTS })

export const getContact = (contactId) => async (dispatch) => {
  try {
    dispatch({ type: ACCOUNT.CLEAR_CONTACT })
    const response = await new API().get(`${URLS.contacts}/${contactId}`)
    dispatch({ type: ACCOUNT.SET_CONTACT, contact: response.data?.contact })
  } catch (error) {
    dispatch({ type: RESPONSE.SET_ERROR, error })
  }
}

export const saveContact =
  (contactId, parameters, onSuccess, onError) => async (dispatch) => {
    try {
      dispatch({ type: ACCOUNT.SET_REQUEST_IS_PENDING, value: true })

      let response
      if (
        contactId &&
        Object.keys(parameters).length === 1 &&
        parameters.primary === 1
      ) {
        response = await new API().put(
          `${URLS.contacts}/${contactId}/primary`,
          parameters,
        )
      } else if (contactId) {
        response = await new API().put(
          `${URLS.contacts}/${contactId}`,
          parameters,
        )
      } else {
        response = await new API().post(`${URLS.contacts}`, parameters)
      }

      dispatch({ type: ACCOUNT.CLEAR_CONTACT })
      dispatch({
        type: ACCOUNT.SET_CONTACTS,
        contacts: response.data?.contacts,
      })
      dispatch({ type: ACCOUNT.SET_REQUEST_IS_PENDING, value: false })
      onSuccess?.()
    } catch (error) {
      dispatch({ type: RESPONSE.SET_ERROR, error })
      dispatch({ type: ACCOUNT.SET_REQUEST_IS_PENDING, value: false })
      onError?.(error)
    }
  }

export const deleteContact = (contactId, onSuccess) => async (dispatch) => {
  try {
    dispatch({ type: ACCOUNT.SET_REQUEST_IS_PENDING, value: true })

    await new API().delete(`${URLS.contacts}/${contactId}`)
    dispatch({ type: ACCOUNT.REMOVE_CONTACT, id: contactId })

    dispatch({ type: ACCOUNT.SET_REQUEST_IS_PENDING, value: false })
    onSuccess?.call()
  } catch (error) {
    dispatch({ type: RESPONSE.SET_ERROR, error })
    dispatch({ type: ACCOUNT.SET_REQUEST_IS_PENDING, value: false })
  }
}

export const clearContact = () => ({ type: ACCOUNT.CLEAR_CONTACT })

export const getCountries = () => async (dispatch) => {
  try {
    dispatch({ type: ACCOUNT.CLEAR_COUNTRIES })
    const response = await new API().get(`${URLS.countries}`)
    dispatch({
      type: ACCOUNT.SET_COUNTRIES,
      countries: response.data?.countries,
    })
  } catch (error) {
    dispatch({ type: RESPONSE.SET_ERROR, error })
  }
}

export const clearCountries = () => ({ type: ACCOUNT.CLEAR_COUNTRIES })

export const getBillingAddresses = () => async (dispatch) => {
  try {
    dispatch({ type: ACCOUNT.CLEAR_BILLING_ADDRESSES })
    const response = await new API().get(`${URLS.billingAddresses}`)
    dispatch({
      type: ACCOUNT.SET_BILLING_ADDRESSES,
      billingAddresses: response.data?.addresses,
    })
  } catch (error) {
    dispatch({ type: RESPONSE.SET_ERROR, error })
  }
}

export const clearBillingAddresses = () => ({
  type: ACCOUNT.CLEAR_BILLING_ADDRESSES,
})

export const getBillingAddress = (billingAddressId) => async (dispatch) => {
  try {
    dispatch({ type: ACCOUNT.CLEAR_BILLING_ADDRESS })
    const response = await new API().get(
      `${URLS.billingAddresses}/${billingAddressId}`,
    )
    dispatch({
      type: ACCOUNT.SET_BILLING_ADDRESS,
      billingAddress: response.data?.address,
    })
    dispatch({
      type: ACCOUNT.SET_COUNTRIES,
      countries: response.data?.countries,
    })
  } catch (error) {
    dispatch({ type: RESPONSE.SET_ERROR, error })
  }
}

export const clearBillingAddress = () => ({
  type: ACCOUNT.CLEAR_BILLING_ADDRESS,
})

export const saveBillingAddress =
  (billingAddressId, parameters, onSuccess, onError) => async (dispatch) => {
    try {
      dispatch({ type: ACCOUNT.SET_REQUEST_IS_PENDING, value: true })

      let response
      if (
        billingAddressId &&
        Object.keys(parameters).length === 1 &&
        parameters.primary === 1
      ) {
        response = await new API().put(
          `${URLS.billingAddresses}/${billingAddressId}/primary`,
          parameters,
        )
      } else if (billingAddressId) {
        response = await new API().put(
          `${URLS.billingAddresses}/${billingAddressId}`,
          parameters,
        )
      } else {
        response = await new API().post(`${URLS.billingAddresses}`, parameters)
      }

      dispatch({ type: ACCOUNT.CLEAR_BILLING_ADDRESS })
      dispatch({
        type: ACCOUNT.SET_BILLING_ADDRESSES,
        billingAddresses: response.data?.addresses,
      })
      dispatch({ type: ACCOUNT.SET_REQUEST_IS_PENDING, value: false })
      onSuccess?.()
    } catch (error) {
      dispatch({ type: RESPONSE.SET_ERROR, error })
      dispatch({ type: ACCOUNT.SET_REQUEST_IS_PENDING, value: false })
      onError?.(error)
    }
  }

export const deleteBillingAddress =
  (billingAddressId, onSuccess) => async (dispatch) => {
    try {
      dispatch({ type: ACCOUNT.SET_REQUEST_IS_PENDING, value: true })

      await new API().delete(`${URLS.billingAddresses}/${billingAddressId}`)
      dispatch({ type: ACCOUNT.REMOVE_BILLING_ADDRESS, id: billingAddressId })

      onSuccess?.call()
      dispatch({ type: ACCOUNT.SET_REQUEST_IS_PENDING, value: false })
    } catch (error) {
      dispatch({ type: RESPONSE.SET_ERROR, error })
      dispatch({ type: ACCOUNT.SET_REQUEST_IS_PENDING, value: false })
    }
  }

export const getHardwareIds = () => async (dispatch) => {
  try {
    dispatch({ type: ACCOUNT.CLEAR_HARDWARE_IDS })
    const response = await new API().get(`${URLS.hardwareIds}`)
    dispatch({
      type: ACCOUNT.SET_HARDWARE_IDS,
      hardwareIds: response.data?.identifiers,
    })
  } catch (error) {
    dispatch({ type: RESPONSE.SET_ERROR, error })
  }
}

export const saveHardwareId =
  (hardwareIdId, parameters, onSuccess, onError) => async (dispatch) => {
    try {
      dispatch({ type: ACCOUNT.SET_REQUEST_IS_PENDING, value: true })

      let response
      if (hardwareIdId) {
        response = await new API().put(
          `${URLS.hardwareIds}/${hardwareIdId}`,
          parameters,
        )
      } else {
        response = await new API().post(`${URLS.hardwareIds}`, parameters)
      }

      dispatch({
        type: ACCOUNT.SET_HARDWARE_IDS,
        hardwareIds: response.data?.identifiers,
      })
      dispatch({ type: ACCOUNT.SET_REQUEST_IS_PENDING, value: false })
      onSuccess?.()
    } catch (error) {
      dispatch({ type: RESPONSE.SET_ERROR, error })
      dispatch({ type: ACCOUNT.SET_REQUEST_IS_PENDING, value: false })
      onError?.(error)
    }
  }

export const deleteHardwareId =
  (hardwareIdId, onSuccess) => async (dispatch) => {
    try {
      dispatch({ type: ACCOUNT.SET_REQUEST_IS_PENDING, value: true })

      await new API().delete(`${URLS.hardwareIds}/${hardwareIdId}`)
      dispatch({ type: ACCOUNT.REMOVE_HARDWARE_ID, id: hardwareIdId })

      onSuccess?.call()
      dispatch({ type: ACCOUNT.SET_REQUEST_IS_PENDING, value: false })
    } catch (error) {
      dispatch({ type: RESPONSE.SET_ERROR, error })
      dispatch({ type: ACCOUNT.SET_REQUEST_IS_PENDING, value: false })
    }
  }

export const clearQuotes = () => ({ type: ACCOUNT.CLEAR_QUOTES })

export const getQuotes = () => async (dispatch) => {
  try {
    dispatch(clearQuotes())
    const response = await new API().get(`${URLS.quotes}`)
    dispatch({ type: ACCOUNT.SET_QUOTES, quotes: response.data })
  } catch (error) {
    dispatch({ type: RESPONSE.SET_ERROR, error })
  }
}

export const clearPurchases = () => ({ type: ACCOUNT.CLEAR_PURCHASES })

export const getPurchases = () => async (dispatch) => {
  try {
    dispatch(clearPurchases())
    const response = await new API().get(`${URLS.purchases}`)
    dispatch({ type: ACCOUNT.SET_PURCHASES, purchases: response.data })
  } catch (error) {
    dispatch({ type: RESPONSE.SET_ERROR, error })
  }
}


export const getLicenseDownloadToken = (id, withToken) => async (dispatch) => {
  try {
    dispatch({ type: ACCOUNT.DOWNLOADING_TOKEN, value: true })
    const response = await new API().get(
      `${APP.downloadToken}?type=license&license_id=${id}`,
    )
    withToken?.call(undefined, response.data.token)
    dispatch({ type: ACCOUNT.DOWNLOADING_TOKEN, value: false })
  } catch (error) {
    dispatch({ type: RESPONSE.SET_ERROR, error })
    dispatch({ type: ACCOUNT.DOWNLOADING_TOKEN, value: false })
  }
}

export const getInvoiceDownloadToken =
  ({ id, type }, withToken) => async (dispatch) => {
    try {
      dispatch({ type: ACCOUNT.DOWNLOADING_TOKEN, value: true })
      const response = await new API().get(
        `${APP.downloadToken}?type=invoice&payment_id=${id}&document_type=${type}`,
      )
      withToken?.call(undefined, response.data.token)
      dispatch({ type: ACCOUNT.DOWNLOADING_TOKEN, value: false })
    } catch (error) {
      dispatch({ type: RESPONSE.SET_ERROR, error })
      dispatch({ type: ACCOUNT.DOWNLOADING_TOKEN, value: false })
    }
  }

export const addQuoteToCartAction = (id, onSuccess) => async (dispatch) => {
  try {
    dispatch({ type: ACCOUNT.SET_REQUEST_IS_PENDING, value: true })

    const response = await new API().post(`${URLS.quotes}/${id}/add-to-cart`)
    dispatch({
      type: ACCOUNT.SET_INTENT_COUNT,
      count: response.data?.intent_count,
    })

    const { data: quotes } = await new API().get(`${URLS.quotes}`)
    dispatch({ type: ACCOUNT.SET_QUOTES, quotes })

    dispatch({ type: ACCOUNT.SET_REQUEST_IS_PENDING, value: false })
    onSuccess?.call()
  } catch (error) {
    dispatch({ type: RESPONSE.SET_ERROR, error })
    dispatch({ type: ACCOUNT.SET_REQUEST_IS_PENDING, value: false })
  }
}

export const clearLicenses = () => ({ type: ACCOUNT.CLEAR_LICENSES })

export const getLicenses = () => async (dispatch) => {
  try {
    dispatch(clearLicenses())
    const response = await new API().get(`${URLS.licenses}`)
    dispatch({ type: ACCOUNT.SET_LICENSES, licenses: response.data })
  } catch (error) {
    dispatch({ type: RESPONSE.SET_ERROR, error })
  }
}

export const createLicense =
  ({ intent_id, hardwareIds }) =>
  async (dispatch) => {
    try {
      dispatch({ type: ACCOUNT.SET_REQUEST_IS_PENDING, value: true })
      await new API().post(`${URLS.licenses}`, {
        intent_id,
        hardware_ids: hardwareIds,
      })
      dispatch(getLicenses())
      dispatch({ type: ACCOUNT.SET_REQUEST_IS_PENDING, value: false })
    } catch (error) {
      dispatch({ type: RESPONSE.SET_ERROR, error })
      dispatch({ type: ACCOUNT.SET_REQUEST_IS_PENDING, value: false })
    }
  }
